// category — or. Canonical bazaar category display names.
// The KEY is the canonical English filter key stored in the database; the
// VALUE is what users read. Never translate the keys — products are matched
// against them.

export default {
  catHandmadeCrafts: 'Kootuu Dogoggoraa',
  catFashion: 'Hanga Fasiin',
  catFoodBeverage: 'Nyaataa dhammuu',
  catBeautyHealth: 'Quramaa Fayyaa',
  catHomeLiving: 'Manaa fi Guyyaa',
  catSportsOutdoors: 'Taphaa fi Alalsaa',
  catBooksMedia: 'Kitaabii fi Mediaa',
  catServices: 'Tajaajila',

  // Subcategory display names
  subPotteryCeramics: 'Koree fi Siramikii',
  subWeavingTextiles: 'Huccuu fi Suqii',
  subJewelryAccessories: 'Faayaa fi Meeshaalee',
  subLeatherGoods: 'Meeshaalee Gobaa',
  subWoodwork: 'Hojii Mukaa',
  subHomeDecor: 'Faayaa Manaa',
  subWomensClothing: 'Uffata Dubartootaa',
  subMensClothing: 'Uffata Dhiirsa',
  subChildrensClothing: 'Uffata Ijoolee',
  subShoesBags: 'Cophee fi Boorsaa',
  subTraditionalClothing: 'Uffata Aadaa',
  subAccessories: 'Meeshaalee Faayaa',
  subCoffeeTea: 'Buna fi Shayii',
  subSpicesGrains: 'Urgooftuu fi Midhaan',
  subHoneySweets: 'Damma fi Mi\'aawaa',
  subTraditionalFood: 'Nyaata Aadaa',
  subColdDrinks: 'Dhugaatii Qorraa',
  subKitchenStaples: 'Meeshaalee Kuchisii',
  subSkincare: 'Qusannaa Gogaa',
  subHaircare: 'Qusannaa Rifeensaa',
  subPerfumeFragrance: 'Urgaa fi Foolii',
  subCosmetics: 'Kosmetii',
  subWellnessSupplements: 'Fayyaa fi Maddii',
  subNaturalRemedies: 'Yaala Uumamaan',
  subFurniture: 'Meeshaa Manaa',
  subKitchenDining: 'Kuchisii fi Nyaataa',
  subBeddingLinens: 'Foornii fi Lalloo',
  subLighting: 'Ifaa',
  subStorage: 'Kuusannaa',
  subSportsEquipment: 'Meeshaalee Taphootaa',
  subFitnessExercise: 'Gammana fi Jimaatii',
  subOutdoorCamping: 'Ala fi Kemeppii',
  subTeamSports: 'Taphoota Garee',
  subCycling: 'Biskileetii',
  subAthleticWear: 'Uffata Aatleetikii',
  subBooksLiterature: 'Kitaabii fi Ogbarruu',
  subStationeryJournals: 'Barreessaa fi Waraqaa',
  subMusicFilm: 'Muziiqaa fi Fiilmii',
  subArtCollectibles: 'Arti fi Meeshaalee Aadaa',
  subMagazines: 'Majaloota',
  subPhotography: 'Suuraa Kaasuu',
  subDesignPrinting: 'Uguummaa fi Maxxansaa',
  subRepairMaintenance: 'Suullifannaa fi Qusannaa',
  subCleaning: 'Qulqulleessuu',
  subPersonalCare: 'Qusannaa Dhuunfaa',
  subClassesTraining: 'Barsiisa fi Leenjii',
};